<template>
  <button class="overlay-close-button" aria-label="Close" @click="close">
    <span v-if="label">{{ label }}</span>
    <template v-else> <i></i><i></i> </template>
  </button>
</template>

<script lang="ts" setup>
import { useOverlayInject } from '../../context/useOverlayContext'

const { close } = useOverlayInject()
const props = defineProps<{ label?: string }>()
</script>

<style lang="scss">
@import '~styles/base';

.overlay-close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  background: none;
  border: none;

  span {
    @include type-xxs-uppercase;
  }

  i {
    width: 15px;
    height: 1px;
    background: #000;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%) rotate(45deg);

    &:last-child {
      transform: translateY(-50%) rotate(-45deg);
    }
  }
}
</style>
